import index from './index';
import progress from './progress';
import { Router } from '@/legacy/Router';

Router.get('judging/leaderboard', index);
Router.get('judging/progress', progress);
